/* unplugin-vue-components disabled */import script from "./MonthHotMeal.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthHotMeal.vue?vue&type=script&setup=true&lang=js"

import "./MonthHotMeal.vue?vue&type=style&index=0&id=c09d5a1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c09d5a1c"]])

export default __exports__